export default "__VITE_ASSET__297f8c5d__"